import { Brand, createBranded } from '@deltasierra/type-utilities';

export type ApiTokenId = Brand<number, 'ApiTokenId'>;
export const ApiTokenId = createBranded<ApiTokenId>();
